import { render, staticRenderFns } from "./VSelectResponsibilityCenter.vue?vue&type=template&id=6d42e998&"
import script from "./VSelectResponsibilityCenter.vue?vue&type=script&lang=js&"
export * from "./VSelectResponsibilityCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d42e998')) {
      api.createRecord('6d42e998', component.options)
    } else {
      api.reload('6d42e998', component.options)
    }
    module.hot.accept("./VSelectResponsibilityCenter.vue?vue&type=template&id=6d42e998&", function () {
      api.rerender('6d42e998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectResponsibilityCenter.vue"
export default component.exports